import { FamilyAccountInfo } from '@backrs_ui/grow-ui/src/redux/family/family.types';

import { Divider, SxProps, Theme } from '@mui/material';

import { InviteFamilyMembers } from './InviteFamilyMembers';
import { ViewFamilyMembers } from './ViewFamilyMembers';

type FamilyPageProps = Readonly<{
  familyAccount: FamilyAccountInfo | undefined;
  returnToDefaultTab: () => void;
}>;

export const FamilyPage = ({ familyAccount, returnToDefaultTab }: FamilyPageProps) => {
  const isOwner = familyAccount?.role === 'owner';

  return (
    <>
      {isOwner && (
        <>
          <InviteFamilyMembers seatUsage={familyAccount.seatUsage} />
          <Divider sx={dividerSx} />
        </>
      )}
      <ViewFamilyMembers familyAccount={familyAccount} returnToDefaultTab={returnToDefaultTab} />
    </>
  );
};

const dividerSx: SxProps<Theme> = ({ backrs }) => ({
  marginBlock: backrs.spacing['spacing-3xl'],
});
